import { Country } from "../utils/database";

export function resolveCurrencyFromCountryId(
  countries: Country[],
  countryId?: number | string | null,
  fallback = "CAD"
): string {
  if (countryId == null || countryId === "") {
    return fallback;
  }

  const normalizedId = Number(countryId);
  if (Number.isNaN(normalizedId)) {
    return fallback;
  }

  const country = countries.find((item) => Number(item.id) === normalizedId);
  if (country?.devise) {
    return country.devise.toUpperCase();
  }

  return fallback;
}
